import React, { useContext } from 'react';
import { ShopContext } from '../context/shopcontext';
import Title from './Title';

const CartTotal = ({ cartData, productMap }) => {
  const { discount = 0 } = useContext(ShopContext);
  const currency = '₹';

  // Calculate subtotal
  const calculateSubtotal = () => {
    return cartData.reduce((total, item) => {
      const product = productMap[item._id];
      if (product) {
        return total + product.price * item.quantity;
      }
      return total;
    }, 0);
  };

  const subtotal = calculateSubtotal();
  const mrpTotal = subtotal * 1.3; // Used for savings hint
  const discountAmount = (subtotal * discount) / 100;
  const total = subtotal - discountAmount;
  const savedAmount = mrpTotal - subtotal;

  const freeShippingThreshold = 500;
  const amountToFreeShipping = freeShippingThreshold - subtotal;
  const shippingProgressPercentage = Math.min(100, (subtotal / freeShippingThreshold) * 100);

  const getProgressBarColor = () => {
    if (shippingProgressPercentage < 40) return 'bg-[#4c0f2e]/30';
    if (shippingProgressPercentage < 80) return 'bg-[#4c0f2e]/60';
    return 'bg-[#4c0f2e]';
  };

  return (
    <div className="w-full rounded-lg border border-[#4c0f2e] p-6 shadow-md bg-white">
      <div className="mb-4 border-b border-gray-200 pb-3">
        <div className="text-2xl">
          <Title text1={'CART '} text2={'TOTAL'} />
        </div>
      </div>

      <div className="space-y-3 text-sm">
        {/* Subtotal */}
        <div className="flex justify-between items-center mb-1">
          <p className="text-gray-600">Subtotal</p>
          <p className="font-medium">
            {currency} {subtotal.toFixed(2)}
          </p>
        </div>

        {/* Coupon Discount */}
        {Number(discount) > 0 && (
          <div className="flex justify-between items-center mb-1">
            <p className="text-gray-600">Coupon Discount ({discount}%)</p>
            <p className="text-green-600">
              - {currency} {discountAmount.toFixed(2)}
            </p>
          </div>
        )}

        {/* Delivery Charges */}
        <div className="flex justify-between items-center mb-1">
          <p className="text-gray-600">Delivery Charges</p>
          {subtotal >= freeShippingThreshold ? (
            <p className="text-green-600 font-medium">FREE</p>
          ) : (
            <p className="text-gray-500 italic text-xs">Calculated at checkout</p>
          )}
        </div>

        {/* Progress Bar */}
        {subtotal < freeShippingThreshold && (
          <div className="mt-2">
            <div className="flex justify-between text-xs mb-1">
              <span></span> {/* Empty space for alignment */}
              <span className="text-[#4c0f2e] font-medium">
                {shippingProgressPercentage.toFixed(0)}%
              </span>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2 border border-[#4c0f2e]/20">
              <div
                className={`h-full rounded-full ${getProgressBarColor()} transition-all duration-500`}
                style={{ width: `${shippingProgressPercentage}%` }}
              ></div>
            </div>
            <p className="text-[#4c0f2e] text-center text-xs mt-2">
              Add{' '}
              <span className="font-bold">
                {currency} {amountToFreeShipping.toFixed(2)}
              </span>{' '}
              more to get <span className="font-bold">FREE DELIVERY</span>
            </p>
          </div>
        )}

        {/* Grand Total */}
        <div className="flex justify-between items-center pt-2 border-t border-gray-200 font-bold text-base">
          <p>Total Amount</p>
          <p className="text-[#4c0f2e]">
            {currency} {total.toFixed(2)}
          </p>
        </div>

        {/* Savings Hint */}
      </div>
    </div>
  );
};

export default CartTotal;
